import React, { Suspense, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import s from "./lazy.module.scss";

interface LazyComponentProps {
  Component: React.ComponentType;
}

const LazyComponent: React.FC<LazyComponentProps> = ({ Component }) => {
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: "100px" });
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (inView && !isLoaded) {
      setIsLoaded(true);
    }
  }, [inView, isLoaded]);

  return (
    <div ref={ref}>
      <Suspense
        fallback={
          <div className={s.loadingContainer}>
            <Skeleton height={400} width="100%" />
          </div>
        }
      >
        {isLoaded ? <Component /> : <Skeleton height={400} width="100%" />}
      </Suspense>
    </div>
  );
};

export default LazyComponent;
